module.exports = __webpack_public_path__ + "img/lot-of-colorful-medication-and-pills-from-above-on-PJPSFTF.09a2e142.jpg";